
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-1 -1 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--primary-highlight)","stroke":"#4fa2b7","stroke-miterlimit":"10","stroke-width":"4","d":"M42.31 7.69L7.69 42.31"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/lineFill.svg